import { company, footer, navLinks } from "../constants";

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-noir-900">
      <div className="section-container py-14">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          {/* Identité */}
          <div className="max-w-sm">
            <p className="font-display font-extrabold text-xl">
              {company.name}
              <span className="text-ferrari">.</span>
            </p>
            <p className="mt-3 text-chrome-dark text-sm leading-relaxed">{footer.tagline}</p>
            <p className="mt-4 text-sm">
              <span className="text-chrome-dark">Zone d'intervention : </span>
              <span className="text-chrome-light">{company.zone}</span>
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-sm font-semibold uppercase tracking-widest text-chrome-dark">
              Navigation
            </p>
            <ul className="mt-4 space-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-chrome-light hover:text-ferrari transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-sm font-semibold uppercase tracking-widest text-chrome-dark">
              Contact
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a
                  href={`tel:${company.phone}`}
                  className="text-chrome-light hover:text-ferrari transition-colors"
                >
                  {company.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${company.email}`}
                  className="text-chrome-light hover:text-ferrari transition-colors"
                >
                  {company.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <p className="text-xs text-chrome-dark">{footer.legal}</p>
          <p className="text-xs text-chrome-dark max-w-md">{footer.notice}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
